import React, { Component } from "react";
import { Glyphicon } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { API } from "aws-amplify";

import "./HistorySquare.css";



export default class HistorySquare extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      marked: this.props.marked,
    };

    this.state['isHovered'] = false;


    this.handleHover = this.handleHover.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    // if (this.props.marked != prevProps.marked) {
    //   this.setState({
    //     marked: this.props.marked
    //   });
    // }
    if (this.props.marked != prevState.marked) {
      this.setState({
        marked: this.props.marked,
      });
    }
  }

  handleHover() {
    this.setState({
      isHovered: !this.state.isHovered
    })
  }

  isWeekend() {
    var day = this.props.date.getDay();
    var isWeekend = (day === 6) || (day === 0);
    return isWeekend;
  }

  render() {
    const btnClass = this.state.isHovered ? "selected " : "";
    const markedColor = this.props.colorScheme + this.props.opacity + ')';

    const editCheckedColor = this.props.colorScheme + .9 + ')';
    const editUnCheckedColor = this.props.colorScheme + .2 + ')';

    const editCheckboxColor = this.props.colorScheme + .9 + ')';

    const hoverColor = this.props.colorScheme + '.3' + ')';
    const disabledColor = 'rgba(226,221,217,.5)';
    const editRemoveColor = 'rgba(80,80,80, .1)';
    const canCheckColor = 'rgba(74,74,74,.2)';


    var bgColor;// = (this.state.isHovered && this.props.markable) ? hoverColor : markedColor;
    var textColor;

    if (this.props.isEditMode) {

      if (this.props.markable) {
        if (this.props.marked) {
          bgColor = markedColor;
          textColor = editCheckedColor;
        } else {
          if (this.state.isHovered) {
            bgColor = editUnCheckedColor;
            textColor = editCheckedColor;
          } else {
            bgColor = editUnCheckedColor;
            textColor = canCheckColor;
          }
        }
      } else {
        // disabledColor
        bgColor = markedColor;
      }

    }

    // } else { //if not in edit mode
    //   bgColor = markedColor;
    //
    //   if (this.props.isToday && this.props.markable) {
    //     bgColor = 'rgba(226,221,217,.1)';;
    //     if (this.props.marked) {
    //       bgColor = markedColor;
    //       if (this.state.isHovered) {
    //         textColor = 'black';
    //       }
    //     } else {
    //       if (!this.state.isHovered) {
    //         textColor = editUnCheckedColor;
    //       } else {
    //         textColor = editCheckedColor;
    //       }
    //     }
    //   }
    //
    // }

    var borderColor = null;

    var divStyle = {
      backgroundColor: bgColor,
      color: textColor,
    };

    if (this.isWeekend()) {
      divStyle['borderTop'] = '3px solid rgba(74, 74, 74, .3)';
      //divStyle['borderBottom'] = '3px solid ' + this.props.colorScheme + 1 + ')';
    }

    if (this.props.markable && this.props.marked) {
      divStyle['borderBottom'] = '3px solid ' + this.props.colorScheme + .9 + ')';
    }
    return (
      <td
        onMouseEnter={ this.handleHover }
        onMouseLeave={ this.handleHover }
        onClick={ this.handleClick }
        className={ "HistorySquare " + btnClass }
        style={ divStyle }
        >
          { this.icon() }
      </td>
    );
  }

  handleClick = async event => {
    event.preventDefault();
    if (!this.props.isEditMode && !this.props.isToday) {
      return;
    }
    if (this.props.markable) {
      if (this.state.isLoading) {
        return;
      }
      this.setState({
        isLoading: true
      });
      var year = this.props.date.getFullYear();
      var date = this.props.date.getDate().pad(2);
      var month = (this.props.date.getMonth() + 1).pad(2);
      var day = (Number(year.toString() + month + date.toString()));
      if (!this.props.marked) {
        await this.props.addDay(day);
        await this.markHabit({
          habitId: this.props.habitId,
          day: day,
        });
        await this.props.loadHabits();
      } else {
        await this.props.removeDay(day);
        await this.unmarkHabit({
          habitId: this.props.habitId,
          day: day,
        });
        await this.props.loadHabits();
      }
      this.setState({
        isLoading: false
      });
    }
  }

  markHabit(habit) {
    this.setState({
      marked: true,
    });
    return API.post("habits", "/habits/" + habit.habitId + "/mark", {
      body: habit
    });
  }

  unmarkHabit(habit) {
    this.setState({
      marked: false
    });
    return API.post("habits", "/habits/" + habit.habitId + "/unmark", {
      body: habit
    });
  }

  icon() {
    // if (!this.props.isRowHovered) {
    //   return null;
    // }

    if (this.props.isEditMode && this.state.isHovered && this.props.markable && this.props.marked) {
      return <Glyphicon className="check" glyph="remove" />;
    }
    if (this.props.isEditMode && this.state.isHovered && this.props.markable && !this.props.marked) {
      return <Glyphicon className="check" glyph="ok" />;
    }

    if (this.props.isEditMode) {
      if (this.props.markable) {
        if (this.props.marked) {
          return <Glyphicon className="check" glyph="ok" />;
        } else {
          return <Glyphicon className="check" glyph="ok" />;
        }
      }
    }

    if (!this.props.isEditMode) {
      if (this.props.isToday) {
        if (this.props.markable) {
          if (!this.props.marked) {
            return <Glyphicon className="check" glyph="ok" />;
          }
          if (this.state.isHovered) {
            return <Glyphicon  className="check" glyph="remove" />;
          }
        }
      }
    }

    //
    // if (this.props.isRowHovered) {
    //   if (this.props.markable && this.props.marked) {
    //     return (
    //       <Glyphicon glyph="remove" />
    //     )
    //   }
    //   if (this.props.markable && !this.props.marked) {
    //     return (
    //       <Glyphicon glyph="ok" />
    //     )
    //   }
    // }
    //
    // if (this.props.markable && this.props.marked) {
    //     return (<Glyphicon glyph="ok" />)
    // }
    //
    // if (this.state.isLoading) {
    //   return (
    //     <Glyphicon glyph="refresh" className="spinning" />
    //   )
    // }
    return null;
  }
}

Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
}



// WEBPACK FOOTER //
// ./src/containers/HistorySquare.js